module.exports = __webpack_public_path__ + "static/media/becomeAHost.01ebb4a0.svg";